var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { browserPaintingDelay, getElementBounds } from '../bound';
import React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useInterval } from './useInterval';
export var useElementPosition = function (options, dependencyList) {
    if (dependencyList === void 0) { dependencyList = []; }
    var element = React.useRef(null);
    var _a = React.useState(getElementBounds(null)), bounds = _a[0], setBounds = _a[1];
    var _b = React.useState(false), hasScrollUpdate = _b[0], setHasScrollUpdate = _b[1];
    var delay = (options === null || options === void 0 ? void 0 : options.refreshDelay) || browserPaintingDelay;
    // Impossible to test the callback because of the useDebouncedCallback
    var refreshOnScroll = useDebouncedCallback(
    // istanbul ignore next
    function () { return setHasScrollUpdate(function (update) { return !update; }); }, delay);
    React.useEffect(function () {
        (options === null || options === void 0 ? void 0 : options.hasScrollRefresh) && document.addEventListener('scroll', refreshOnScroll);
        return function () {
            (options === null || options === void 0 ? void 0 : options.hasScrollRefresh) && document.removeEventListener('scroll', refreshOnScroll);
        };
    }, [options === null || options === void 0 ? void 0 : options.hasScrollRefresh, refreshOnScroll]);
    var setRef = React.useCallback(function (node) {
        if (!node) {
            return;
        }
        element.current = node;
        setBounds(getElementBounds(node));
    }, []);
    var clearInterval = useInterval(function () {
        var nextBounds = getElementBounds(element.current);
        JSON.stringify(nextBounds) !== JSON.stringify(bounds) ? setBounds(nextBounds) : clearInterval();
    }, delay, __spreadArray([JSON.stringify(bounds), (options === null || options === void 0 ? void 0 : options.hasScrollRefresh) ? hasScrollUpdate : false], dependencyList, true));
    return { bounds: bounds, setRef: setRef };
};
